import type { LocationQuery } from 'vue-router'
import type { FactureQueryDTO } from '@/features/api/extranet/dto/Facture/FactureQueryDTO'
import { useRechercheFactureStore } from './useRechercheFactureStore'
import { locationQueryValueToArray, parseBool, parseIntWithDefault } from '@/features/shared/tools'
import type { PagedRequest } from '../storeRechercheBuilder'
import { provideLoadRechercheService } from '../rechercheRoutingServiceProvider'
import { buildRechercheRoutingService } from '../rechercheRoutingServiceBuilder'
import type { Periode } from '@/features/domaine/types/opco/shared/Periode'

export function useRechercheFactureRoutingService() {
  return buildRechercheRoutingService<FactureQueryDTO>(useRechercheFactureStore, parseLocationQuery)
}
provideLoadRechercheService('facture', useRechercheFactureRoutingService)

function parseLocationQuery(query: LocationQuery): PagedRequest<FactureQueryDTO> {
  const loadParams: PagedRequest<FactureQueryDTO> = {
    query: {
      search: locationQueryValueToArray(query.search),
      avecAlerteActionAFaire: parseBool(query.avecAlerteActionAFaire as string),
      statuts: locationQueryValueToArray(query.statuts, []) as any,
      periodeDateReception: (query.periodeDateReception as Periode) ?? '',
      periodeDateEmission: (query.periodeDateEmission as Periode) ?? '',
      dateDebutReception: (query.dateDebutReception as string) ?? '',
      dateFinReception: (query.dateFinReception as string) ?? '',
      dateDebutDateEmission: (query.dateDebutDateEmission as string) ?? '',
      dateFinDateEmission: (query.dateFinDateEmission as string) ?? '',
    },
    orderBy: locationQueryValueToArray(query.orderBy, [])!, // verifier
    pagination: {
      pageNumber: parseIntWithDefault(query.pageNumber as string, 1)!,
      pageSize: parseIntWithDefault(query.pageSize as string) as number | undefined,
    },
  }
  return loadParams
}

